import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { CommonModule, NgFor, NgIf, NgOptimizedImage } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatDrawer, MatSidenavModule } from "@angular/material/sidenav";
import { Subject, Subscription, takeUntil } from "rxjs";
import { ActivatedRoute } from "@angular/router";
import * as _moment from "moment";
// tslint:disable-next-line:no-duplicate-imports
import { default as _rollupMoment, Moment } from "moment";
import { DynamicSettingsService } from "app/layout/common/dynamic-settings/dynamic-settings.service";
import { ModalComponent } from "app/modules/shared/modal.component";
import { DynamicFormComponent } from "app/modules/shared/forms/dynamic-form/dynamic-form.component";
import { FuseConfirmationService } from "@fuse/services/confirmation";
import { FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { UserService } from "app/core/user/user.service";
import { fuseAnimations } from "@fuse/animations";
import { cloneDeep } from "lodash";
import { KeyPairsComponent } from "app/modules/shared/key-pairs/key-pairs.component";
import { GridsComponent } from "app/modules/shared/grids/grids.component";
import { TableComponent } from "app/modules/shared/table/table.component";
import { FuseScrollbarDirective } from "@fuse/directives/scrollbar";
import { MaterialModule } from "app/material.module";
import { AppFilterPipeModule } from "app/_filters/app.filter-pipe.module";
import { FuseAlertComponent } from "@fuse/components/alert";
import { CommonService } from "app/_services/common.service";
import { LoaderService } from "app/_services/loader.service";
import { BaseRequestService } from "app/_services/base.service";
import { MyToastrService } from "app/_services/toastr.service";
import { MatSelect } from "@angular/material/select";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { ModalService } from "app/_services/modal.service";
import { Clipboard } from "@angular/cdk/clipboard";
const moment = _rollupMoment || _moment;

@Component({
  selector: "app-partner-users",
  standalone: true,
  imports: [
    CommonModule,
    GridsComponent,
    KeyPairsComponent,
    MatButtonModule,
    MatIconModule,
    MatSidenavModule,
    ModalComponent,
    TableComponent,
    FuseScrollbarDirective,
    MaterialModule,
    AppFilterPipeModule,
    DynamicFormComponent,
    FuseAlertComponent,
    NgIf,
    NgFor,
    ReactiveFormsModule,
    FormsModule,
    NgxMatSelectSearchModule,
  ],
  templateUrl: "./partner-users.component.html",
  styleUrls: ["./partner-users.component.scss"],
})
export class PartnerUsersComponent {
  @ViewChild("drawer") drawer: MatDrawer;
  apiKeyData: any=[];
  showFullSecret = false;
  drawerPosition: "start" | "end" = "end";
  drawerMode: "over" | "side" = "side";
  drawerOpened: boolean = false;
  @ViewChild("companySelect", { static: true }) companySelect!: MatSelect;
  public companyCtrl: FormControl = new FormControl();
  public companyFilterCtrl: FormControl = new FormControl();
  public searching = false;
  searchTxt: any = "Search Distributor";
  cAsset: any;
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  deviTableOptions: any = {};
  addUserData: any = {}
  companyId: any;
  private subs: Subscription;
  private site: Subscription;
  addUser: any = {};
  scanAsset: any = {};
  distributorsData: any;
  importance: any = [
    { key: "Low", value: "25" },
    { key: "Medium", value: "50" },
    { key: "High", value: "75" },
    { key: "Critical", value: "100" },
  ];
  formElements: any = [
    {
      name: "firstname",
      description: "Enter First Name",
      example: "",
      min: 3,
      max: 25,
      required: true,
      schema: {
        type: "text",
      },
    },
    {
      name: "lastname",
      description: "Enter Last Name",
      example: "",
      min: 3,
      max: 25,
      required: true,
      schema: {
        type: "text",
      },
    },
    {
      name: "Email",
      description: "Enter Email",
      required: true,
      schema: {
        type: "text",
      },
    },
    {
      name: "Role",
      description: "Choose Role",
      required: true,
      options: this.importance,
      schema: {
        type: "dropdown",
      },
    },
    {
      name: "alldistributors",
      description: "All Distributors",
      schema: {
        type: "checkbox",
      },
    },
    {
      name: "specificdistributors",
      description: "Specific Distributors",
      schema: {
        type: "checkbox",
      },
    },
  ];
  scanTypeList = [
    { key: "Full Scan", value: 1 },
    { key: "Asset Scan", value: 2 },
    { key: "Active Directory Scan", value: 5 },
    { key: "SNMP Scan", value: 6 },
    { key: "LightWeight Agent Scan", value: 7 },
    { key: "Firewall Scan", value: 8 },
    { key: "PII Scan", value: 9 },
  ];
  addpartnerFormElements = [];
  scanformElements: any;
  formScanElements: any = [
    {
      name: "scan_type",
      description: "Scan Type",
      example: "",
      required: true,
      searching: false,
      options: [
        { displayName: "Full Scan", value: "FULLSCAN" },
        { displayName: "Active Directory Scan", value: "ADSCAN" },
        { displayName: "Network Scan", value: "NETWORKSCAN" },
      ],
      schema: {
        type: "dropdown",
        key: "displayName",
        value: "value",
      },
    },
  ];
  suppressData: any = {};
  internalUsers: any = [];

  fromDate = new Date();
  fromMinEndDate: any = null;
  currentUser: any = "";
  rolesData: any;
  reasonsList: string[] = [
    "Justified for business reasons",
    "False Positive",
    "Compensating control in place",
    "Other",
  ];
  /**
   * Constructor
   */
  constructor(
    private cs: CommonService,
    private loaderService: LoaderService,
    private route: ActivatedRoute,
    private _ds: DynamicSettingsService,
    private _bs: BaseRequestService,
    public _modalService: ModalService,
    public _userService: UserService,
    private toast: MyToastrService,
    public confirmDialog: FuseConfirmationService,
    private clipboard: Clipboard,
  ) {
    this.subs = this._ds.partnerUsers.subscribe((res: any) => {
      this.assetActionCall(res);
      // if (res.target === "add-partner") {
      //   this.addpartnerFormElements = [];
      //   this.addNewAsset();
      // }
      // if (res.target === "edit-partner") {
      //   if (this.cs.selectedTableRows && this.cs.selectedTableRows.length) {
      //     this.addEditAsset(this.cs.selectedTableRows[0]);
      //   } else {
      //     this.toast.sToast("info", "Please select at least one asset.");
      //   }
      // }
      // if (res.target === "delete-partner") {
      //   this.deleteAsset(this.cs.selectedTableRows);
      // }
      // if (res.target === "apikey-partner") {
      //   if (this.cs.selectedTableRows && this.cs.selectedTableRows.length) {
      //     this.getApiKey(this.cs.selectedTableRows[0]);
      //   } else {
      //     this.toast.sToast("info", "Please select at least one asset.");
      //   }
      // }
    });
    this.site = this.cs.selectedSiteChanged.subscribe((res) => {
      if (this.drawer.opened) {
        this.drawer.toggle().then((r) => console.log(r));
      }
    });
    try {
      this.route.data.subscribe((v: any) => {
        this.deviTableOptions = {
          columns: [
            {
              header: "First Name",
              columnDef: "first_name",
              cType: "string",
              filter: "",
              cell: "(element: any) => `${element.first_name}`",
              order: 0,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              header: "Last Name",
              columnDef: "last_name",
              cType: "string",
              filter: "",
              cell: "(element: any) => `${element.last_name}`",
              order: 0,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              header: "Email",
              columnDef: "email",
              cType: "string",
              filter: "",
              cell: "(element: any) => `${element.email}`",
              order: 0,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              header: "Roles",
              columnDef: "roles",
              cType: "string",
              filter: "",
              cell: "(element: any) => `${element.roles}`",
              order: 0,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
          ],
          sortOptions: { active: "email", direction: "asc" },
          _pageData: [],
          tableOptions: {
            title: "Users",
            isServerSide: false,
            selectText: "users(s)",
            loading: true,
            floatingFilter: true,
            rowSelection: false,
            showAction: true,
            actionMenuItems: [
              {
                name: "Edit User",
                text: "Edit User",
                id: "edit-partner",
                icon: "feather:edit",
                target: "edit-partner",
                emtterAction: "partnerUsers",
                callback: 'editFunction',
                isGlobal: false,
              },
              // {
              //   name: "Delete User",
              //   text: "Delete User",
              //   id: "delete-partner",
              //   icon: "mat_outline:delete",
              //   target: "delete-partner",
              //   emtterAction: "partnerUsers",
              // },
              {
                name: "Api Key",
                text: "Api Key",
                id: "apikey-partner",
                icon: "mat_outline:vpn_key",
                target: "apikey-partner",
                emtterAction: "partnerUsers",
                callback: 'editFunction',
                isGlobal: false,
              },
            ],
            pagination: true,
            pageOptions: [5, 10, 25, 100],
            pageSize: 10,
            search: false,
            saveData: true,
            showhideList: true,
            refreshData: true,
            showFilter: true,
            showTagFilter: false,
            exportExcel: true,
            add: true,
            columnSearch: false,
            compareData: false,
            filterDownload: false,
            serverSide: {
              url: "/r/user/get_users",
              condition: true,
              type: "get",
            },
          },
          changeValue: new Subject<any>(),
        };
      });
    } catch (error) {
      console.error("Error retrieving route data:", error);
    }
  }
  getApiKey(data) {
    console.log('data', data);
    const condition = {
      condition: true,
    };
    this._bs
      .doRequest(`/r/user/generate_secret/${data.id}`, "get", null, condition)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((result: any) => {
        if (result.status) {
          console.log('result', result);
          this.apiKeyData = result.data;
          this._modalService.open("displayApiKeyData");
        } else {
          this.toast.sToast("error", result.message);
        }
      });

  }
  UpdateUser(addUserData) {
    const reqData: any = {
      roles: [addUserData.roles],
      included: (addUserData.distributorTypeData === 'allowed') ? addUserData.distributor.join(',') : "",
      excluded: (addUserData.distributorTypeData === 'excluded') ? addUserData.distributor.join(',') : "",
    }
    reqData.user_id = addUserData.id;
    if (this.cs.currentScope !== "*") {
      reqData.distributor_id = this.cs.currentScope.id;
    }
    this.loaderService.display(true);
    this._bs
      .doRequest(`/w/user/update_role`, "post", reqData)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((result: any) => {
        this.loaderService.display(false);
        if (result.status) {
          this.toast.sToast("success", "User updated successfully!");
          this.drawerOpened = false;
          addUserData = {};
          setTimeout(() =>
            this.deviTableOptions.changeValue.next(true)
          );
        } else {
          this.toast.sToast("error", result.message);
        }
      });
  }
  AddUser(addUserData) {
    const reqData: any = {
      email: addUserData.email,
      first_name: addUserData.first_name,
      last_name: addUserData.last_name,
      roles: [addUserData.roles],
      included: (addUserData.distributorTypeData === 'allowed') ? addUserData.distributor.join(',') : "",
      excluded: (addUserData.distributorTypeData === 'excluded') ? addUserData.distributor.join(',') : "",
      password: "",
      mobile:"",
    }
    if (this.cs.currentScope !== "*") {
      reqData.distributor_id = this.cs.currentScope.id;
    }
    this.loaderService.display(true);
    this._bs
      .doRequest(`/w/user/create_user`, "post", reqData)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((result: any) => {
        this.loaderService.display(false);
        if (result.status) {
          this.toast.sToast("success", "User added successfully!");
          this.drawerOpened = false;
          addUserData = {};
          setTimeout(() =>
            this.deviTableOptions.changeValue.next(true)
          );
        } else {
          this.toast.sToast("error", result.message);
        }
      });
  }
  toggleSecretVisibility() {
    this.showFullSecret = !this.showFullSecret;
  }

  copyOption(option:string){
    if (option) {
      this.clipboard.copy(option);
      this.toast.sToast("success", "Copied to clipboard");
    }
  }
  ngOnInit(): void {
    // this.getAsset(this.route.snapshot.paramMap.get("id"));
    this._userService.userd$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((user: any) => {
        this.currentUser = user["email"];
      });
    this.scanformElements = this.cs.processFormElements(this.formScanElements);
  }
  changeEvent(event: any) {
    this.fromMinEndDate = this.cs.getLastDay(1, event.value);
  }

  linkClick($event: any) {
    this.cAsset = undefined;
    this.cs.selctedAsset = $event.row.id;
    setTimeout(() => {
      this.viewAsset($event.row);
    }, 100);
  }

  viewAsset(asset: any): void {
    this.loaderService.display(true);
    this.cAsset = asset;
    this.drawerOpened = true;
    if (!this.drawer.opened) {
      this.drawer.toggle().then((r) => console.log(r));
    }
  }

  filterTags($event: any): void {
    console.log($event);
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
    this.subs.unsubscribe();
    this.site.unsubscribe();
  }

  tabFn($event: any): void {
    switch ($event) {
      case 0:
        const data = Object.assign({}, this.deviTableOptions);
        this.deviTableOptions = {};
        this.deviTableOptions.pageData = [];
        this.deviTableOptions.tableOptions.pageTotal = 0;
        data.pageData = [];
        data.tableOptions.pageTotal = 0;
        this.deviTableOptions = data;
        break;
      default:
        break;
    }
  }

  toggleChange($event: any): void {
    this.cs.selctedAsset = "";
    this.drawer.toggle();
  }

  addNewAsset() {
    this.drawerOpened = true;
    this.getRoles();
    this.getCompanies();
    if (!this.drawer.opened) {
      this.drawer.toggle().then((r) => console.log(r));
    }
  }
  newUser(){
    this.addUserData={};
    this.addNewAsset();
  }
  assetActionCall(res: any): void {
    const tableName: any = this.deviTableOptions.tableOptions.title;
        if (res.target === "edit-partner") {
        if (this.cs.selectedTableRows[tableName] && this.cs.selectedTableRows[tableName].length) {
          this.addEditAsset(this.cs.selectedTableRows[tableName][0]);
        } else {
          this.toast.sToast("info", "Please select at least one asset.");
        }
      }
      if (res.target === "delete-partner") {
        this.deleteAsset(this.cs.selectedTableRows[tableName]);
      }
      if (res.target === "apikey-partner") {
        if (this.cs.selectedTableRows[tableName] && this.cs.selectedTableRows[tableName].length) {
          this.getApiKey(this.cs.selectedTableRows[tableName][0]);
        } else {
          this.toast.sToast("info", "Please select at least one asset.");
        }
      }
  }
  actionCall(data: any) {
    const tableName: any = this.deviTableOptions.tableOptions.title;
    this.cs.selectedTableRows[tableName] = [data.row];
    this.assetActionCall(data.action);
  }
  addEditAsset(editData) {
    if(Array.isArray(editData.roles)) {
      editData.roles = editData.roles[0];
    }
    if (editData.included == "" && editData.excluded == "") {
      editData.distributorType = 'all'
    } else {
      editData.distributorType = 'specific'
    }
    if (editData.included !== "") {
      editData.distributorTypeData = 'allowed'
    } else if (editData.excluded !== "") {
      editData.distributorTypeData = 'excluded'
    }
    editData.distributor = (editData.included) ? [parseInt(editData.included)] : [parseInt(editData.excluded)];
    this.addUserData = editData;
    this.drawerOpened = true;
    this.getRoles();
    this.getCompanies();
    if (!this.drawer.opened) {
      this.drawer.toggle().then((r) => console.log(r));
    }

  }
  getRoles() {
    const condition = {
      condition: true,
      skip: 0,
      limit: 100,
      order_by: "name asc",
    };
    this._bs
      .doRequest("/r/user/get_roles", "get", null, condition)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((result: any) => {
        if (result.status) {
          this.rolesData = result.data;
        }
      });
  }
  getCompanies(search?: string): void {
    const condition = search
      ? { condition: "distributor_name ilike '%" + search + "%'" }
      : {
        condition: true,
        skip: 0,
        limit: 100,
        order_by: "distributor_name asc",
      };
    this._bs
      .doRequest("/r/distributors/distributors", "get", null, condition)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((result: any) => {
        if (result.status) {
          this.distributorsData = result.data;
        }
      });
  }
  saveAsset($event: any): void {
    const request: any = $event;
    if (this.cs.currentScope !== "*") {
      request.distributor_id = this.cs.currentScope.id;
    }
    this.loaderService.display(true);
    this._bs
      .doRequest(`w/asset/assets`, "post", { data: request })
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((result: any) => {
        this.loaderService.display(false);
        if (result.status) {
          this.toast.sToast("success", "Asset added successfully!");
          this._modalService.close("addNewAssetModal");
          setTimeout(() => this.deviTableOptions.changeValue.next(true));
        } else {
          this.toast.sToast("error", "Asset not added!");
        }
      });
  }

  deleteAsset($event: any): void {
    const confirmation = this.confirmDialog.open({
      title: "Confirmation",
      message: `Are you sure you want to delete User?`,
      actions: {
        confirm: {
          label: "Yes",
        },
      },
    });
    confirmation.afterClosed().subscribe((result) => {
      if (result === "confirmed") {
        const reqData: any = {
          ids: this.cs.selectedTableRows.map((obj: any) => obj.id),
        };
        this._bs
          .doRequest(`d/asset/assets/bulk_delete`, "post", reqData)
          .pipe(takeUntil(this._unsubscribeAll))
          .subscribe((result: any) => {
            if (result.status) {
              this.toast.sToast("success", "Removed successfully");
              setTimeout(() => this.deviTableOptions.changeValue.next(true));
            } else {
              this.toast.sToast("error", result.message);
            }
          });
      }
    });
  }

  clearDistributors() {
    this.addUserData.distributor = [];
  }
}
